import { NavLink } from "react-router-dom";
import { CalendarDays, Compass, Heart, Home, Map } from "lucide-react";
import { useFavorites } from "@/lib/favorites";

const TABS = [
  ["/", "Start", Home, true],
  ["/entdecken", "Entdecken", Compass],
  ["/veranstaltungen", "Termine", CalendarDays],
  ["/karte", "Karte", Map],
  ["/merkliste", "Merkliste", Heart],
];

export const BottomTabBar = () => {
  const { ids } = useFavorites();
  return (
    <nav className="fixed inset-x-0 bottom-0 z-[60] border-t border-foreground/10 bg-shell/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl md:hidden" aria-label="Hauptnavigation" data-testid="bottom-tab-bar">
      <ul className="grid h-16 grid-cols-5">
        {TABS.map(([to, label, Icon, end]) => (
          <li key={to}>
            <NavLink to={to} end={end} data-testid={`tab-${label.toLowerCase()}`}
              className={({ isActive }) => `relative flex h-full flex-col items-center justify-center gap-1 text-[0.7rem] font-sub transition-colors ${isActive ? "text-terracotta" : "text-foreground/70 active:text-foreground"}`}>
              {({ isActive }) => (
                <>
                  {isActive && <span className="absolute top-0 h-0.5 w-8 bg-terracotta" />}
                  <span className="relative">
                    <Icon size={21} strokeWidth={isActive ? 2 : 1.5} />
                    {to === "/merkliste" && ids.length > 0 && (
                      <span className="absolute -right-2.5 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-terracotta px-1 text-[0.6rem] text-white" data-testid="tab-favorites-count">{ids.length}</span>
                    )}
                  </span>
                  {label}
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
